import { Component } from '@angular/core';
import { FBAbstractControl } from '../abstract.control';

@Component({
  selector: 'fb-controls-datetime',
  templateUrl: './date-time.component.html',
  styleUrls: [],
})
export class FBDateTimeComponent extends FBAbstractControl {
  constructor() {
    super();
  }

  static PROPERTIES() {
    return Object.freeze({
      common: {
        ...FBAbstractControl.DefaultProperties(),
      },
      booleans: {
        ...FBAbstractControl.BooleansProperties(),
      },
    });
  }
}
